import { CircularProgress, Grid, Typography } from '@material-ui/core'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Button, ButtonProps } from './../button/button'

const StyledLoadingText = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(12)};
  padding-bottom: ${props => props.theme.typography.pxToRem(10)};
`

export type LoadMoreButtonProps = {
  loadedItems: number
  totalNumber: number
  isLoading: boolean
} & ButtonProps

export const LoadMoreButton: React.FC<PropsWithChildren<LoadMoreButtonProps>> = ({ loadedItems, totalNumber, children, isLoading, ...props }) => {
  return (
    <Grid container item xs={12} md={12} justifyContent="center" alignItems="center" direction="column">
      <StyledLoadingText variant="body1">{loadedItems} / {totalNumber}</StyledLoadingText>
      {
        loadedItems < totalNumber
          ? <Button {...props} disabled={isLoading}>
            {
              isLoading
                ? <CircularProgress variant="indeterminate" size={20} />
                : children
            }
          </Button>
          : null
      }
    </Grid>
  )
}